export const questions = [
  {
    code: "product_design_change",
    question: "Is this a Product / Design change?",
  },
  {
    code: "quality_system_change",
    question: "Is this a Quality System change?",
  },
  {
    code: "product_range_change",
    question: "Is this a Product Range change?",
  },
  {
    code: "A1",
    question: "Does it affect intended purpose, indications, warnings, performance, clinical/safety evidence, essential requirements, or the design dossier?",
  },
  {
    code: "B",
    question: "Is this a software change?",
  },
  {
    code: "B1",
    question: "Does software alter diagnosis/therapy, algorithms, data interpretation, closed-loop control, alarms, diagnostic/therapeutic features, or OS/platform?",
  },
  {
    code: "B2",
    question: "Is the change only UI appearance, reporting/printing/language, non-clinical enhancement, or a bug fix with no safety impact?",
  },
  {
    code: "C",
    question: "Is this a material change?",
  },
  {
    code: "C1",
    question: "Is the material of human origin, animal origin, or TSE-related?",
  },
  {
    code: "C2",
    question: "Does material change affect biocompatibility, stability, performance, clinical evidence, tissue/fluid contact, or implants in contact >30 days?",
  },
  {
    code: "C3",
    question: "Did the supplier change?",
  },
  {
    code: "C4",
    question: "Is the supplier critical or crucial?",
  },
  {
    code: "C5",
    question: "Does the material still meet approved specifications?",
  },
  {
    code: "S",
    question: "Is this a supplier or subcontractor change?",
  },
  {
    code: "S1",
    question: "Is the supplier critical or crucial?",
  },
  {
    code: "S2",
    question: "Does the material or process still meet approved specifications?",
  },
  {
    code: "D",
    question: "Is this a labeling change?",
  },
  {
    code: "D1",
    question: "Does the labeling change intended use, indications, contraindications, warnings/precautions, or shelf life?",
  },
  {
    code: "D2",
    question: "Is the change only layout, wording clarification, translation, or usability clarification?",
  },
  {
    code: "E",
    question: "Is this a manufacturing process, facility, or equipment change?",
  },
  {
    code: "E1",
    question: "Does it affect safety/performance, validated process, mfg tech, cleanroom/environmental controls, production transfer, or acceptance criteria?",
  },
  {
    code: "E2",
    question: "Does the process remain within validated specifications?",
  },
  {
    code: "F",
    question: "Any change to sterilization method, cycle parameters, provider, sterile packaging, load configuration, bioburden limits, or validation method?",
  },
  {
    code: "G1",
    question: "Does change affect regulatory/ISO 13485 compliance, org structure, process interactions, supplier controls, manufacturing tech, or site locations?",
  },
  {
    code: "H1",
    question: "Are new subcategories or generic device groups being added or removed?",
  },
  {
    code: "significant",
    question: "The change is considered a significant per EU MDR / NBOG 2014-3 Change Assessment", lastState: true
  },
  {
    code: "non_significant",
    question: "The change is considered a non-significant per EU MDR / NBOG 2014-3 Change Assessment", lastState: true
  },
]
;
